var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFrogGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "15e1nwt0ua",
    d: "M0 0H19V19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dx16ao97cb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#15e1nwt0ua"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#40C706",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#dx16ao97cb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 18 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.294L0.272 16.685"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFrogGreen);
export default __webpack_public_path__ + "static/media/search-frog-green.30d73ba60d28c6254c39442c277cb0f3.svg";
export { ForwardRef as ReactComponent };